import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostNarcissismGaslightingFR() {
  const articleData = {
    title: 'Apprenez les termes : Narcissisme & Gaslighting',
    description: "Apprenez sur le narcissisme et le gaslighting. Comprenez les tactiques de manipulation et comment l'IA détecte les schémas toxiques dans les textes.",
    slug: 'narcissism-gaslighting-explained',
    publishDate: '2025-07-15',
    author: 'Rédaction Toxic Detector'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Lien copié dans le presse-papiers !');
    }
  };
  return <>
      <MetaTags title="Narcissisme & Gaslighting expliqués | ToxicDetector" description="Comprenez la psychologie derrière les tactiques de manipulation du narcissisme et du gaslighting." keywords="narcissisme, gaslighting, manipulation, psychologie, analyse IA" canonical={`https://toxicdetector.com/fr/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/iLMUMmEFFWiRSqv8DSTAdz/file_00000000f0c8720a9c4e7f9e2fbdea6d.png" schema={[articleSchema]} data-id="element-5915" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-5916">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-5917">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-5918">
            <div className="flex items-center justify-between" data-id="element-5919">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-5920">
                <span className="text-2xl" data-id="element-5921">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-5922">
                  ToxicDetector
                </span>
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-5923">
                <Share2 size={20} className="text-gray-600" data-id="element-5924" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-5925">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-5926">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-5927" />
            Retour à l'Accueil
          </Link>

          <header className="mb-16" data-id="element-5928">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-5929">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-5930">
              <time dateTime={articleData.publishDate} data-id="element-5931">
                {new Date(articleData.publishDate).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-5932">•</span>
              <span data-id="element-5933">{articleData.author}</span>
            </div>
          </header>

          <div className="prose prose-lg max-w-none" data-id="element-5934">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-5935">
              Narcissisme et gaslighting sont des termes souvent utilisés, mais
              que signifient-ils vraiment ? Et comment sont-ils liés ?
            </p>

            <section className="mb-16" data-id="element-5936">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5937">
                Qu'est-ce que le Narcissisme ?
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5938">
                Le narcissisme est plus que de la vanité. C'est un trait de
                personnalité caractérisé par un sentiment exagéré de sa propre
                importance, un besoin profond d'admiration et un manque
                d'empathie.
              </p>
            </section>

            <section className="mb-16" data-id="element-5939">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5940">
                Qu'est-ce que le Gaslighting ?
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5941">
                Le gaslighting est une forme de manipulation psychologique dans
                laquelle une personne sème le doute dans la perception, la
                mémoire ou le jugement d'une autre personne.
              </p>
            </section>

            <section className="mb-16" data-id="element-5942">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5943">
                Le Lien
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5944">
                Les narcissiques utilisent souvent le gaslighting comme un outil
                pour maintenir le contrôle et protéger leur image de soi. C'est
                une combinaison dangereuse.
              </p>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl mt-16" data-id="element-5945">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-5946">
              Reconnaissez les signes.
            </h2>
            <p className="text-purple-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-5947">
              Ne vous laissez pas manipuler. Utilisez l'IA pour obtenir de la
              clarté.
            </p>
            <Link to="/upload" className="inline-block bg-white text-purple-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-5948">
              Scanner maintenant →
            </Link>
          </div>

          <div className="mt-20" data-id="element-5949">
            <RelatedBlogPosts posts={[{
            title: '7 Signes de Gaslighting',
            description: 'Découvrez 7 signes de gaslighting que notre IA détecte instantanément.',
            slug: '7-signs-of-gaslighting',
            emoji: '💀'
          }, {
            title: 'Votre ex est-il un narcissique caché ?',
            description: 'Découvrez si votre ex montre des signes de comportement narcissique caché.',
            slug: 'is-your-ex-a-covert-narcissist',
            emoji: '🎭'
          }]} data-id="element-5950" />
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-5951">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-5952">
            <p className="text-gray-400 text-sm" data-id="element-5953">
              © {new Date().getFullYear()} ToxicDetector. Tous droits réservés.
            </p>
          </div>
        </footer>
      </div>
    </>;
}